import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getChannelTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}channeltype`);
      let data = response["data"];
      context.commit("updateChannelTypesData", data);
    },
    async createChannelTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}channeltype/store`, body, config);
      context.dispatch("getChannelTypesData");
    },
    async pushChannelTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}channeltype/update`, body, config);
      context.dispatch("getChannelTypesData");
    },
    async destroyChannelTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}channeltype/destroy`, body, config);
      context.dispatch("getChannelTypesData");
    }
  },
  mutations: {
    updateChannelTypesData(state, channelTypesData) {
      state.channelTypesData = channelTypesData;
    }
  },
  state: {
    channelTypesData: []
  },
  getters: {
    allChannelTypesData(state) {
      return state.channelTypesData;
    }
  }
};